import React from "react";
import { Archive, Inbox } from "lucide-react";

/**
 * Two-state pill toggle: "Actifs" (default) vs "Archives".
 * Keeps completed items tucked away so the default view shows only live work.
 */
export function ArchiveToggle({ showArchived, onChange, activeCount, archivedCount, t }) {
  const label = (k, fallback) => {
    const v = t ? t(k) : k;
    return v === k ? fallback : v;
  };
  return (
    <div className="inline-flex rounded-full bg-slate-100 p-1" data-testid="archive-toggle">
      <button
        type="button"
        onClick={() => onChange(false)}
        data-testid="archive-toggle-active"
        className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${!showArchived ? "bg-white text-findo-indigo card-shadow" : "text-slate-500 hover:text-slate-700"}`}>
        <Inbox size={14} /> {label("arch.active", "Active")}
        {typeof activeCount === "number" ? ` (${activeCount})` : ""}
      </button>
      <button
        type="button"
        onClick={() => onChange(true)}
        data-testid="archive-toggle-archived"
        className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${showArchived ? "bg-white text-findo-navy card-shadow" : "text-slate-500 hover:text-slate-700"}`}>
        <Archive size={14} /> {label("arch.archived", "Archived")}
        {typeof archivedCount === "number" ? ` (${archivedCount})` : ""}
      </button>
    </div>
  );
}

export default ArchiveToggle;
